import script from "./ReviewProjectsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewProjectsView.vue?vue&type=script&setup=true&lang=js"

import "./ReviewProjectsView.vue?vue&type=style&index=0&id=0870085e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0870085e"]])

export default __exports__